"use strict";

var _require = require('react'),
    useContext = _require.useContext;

var _require2 = require('./TranslationProvider'),
    I18nContext = _require2.I18nContext;

function useI18n() {
  return useContext(I18nContext);
}

module.exports = {
  useI18n: useI18n
};